import { displayName } from '../../../App';
import Content from '../../components/Pages/Notifications';
import NotificationsLayout from '../../components/Layout/Notifications';
import { ENotificationsContextProvider } from '../../context/e-notifications';

function Notifications() {
  document.title = `${displayName}: Notifications`;

  return (
    <NotificationsLayout>
      <ENotificationsContextProvider>
        <Content />
      </ENotificationsContextProvider>
    </NotificationsLayout>
  );
}

export default Notifications;
